<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalHelpIndex]="helpIndex"
    [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="checkOk()" (closeButtonActionEmt)="closeModal()"
    [modalClass]="modalClass" [isPrimaryBtnEnabled]="okEnabled()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [buttonTemplate]="validateButtonTemplate">

    <div class="settings-panel-header">Realm Node</div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="nodeName" requiredAsterisk>Name: </label>
        </div>
        <div class="modal-row-column-max">
            <input (focus)="resetClickClosed()" (focusout)="validateOnBlur(nodeName, 'Realm Node')" (keyup)="validateName(nodeName, 'Realm Node')"
                (change)="onChangeNodeName(nodeName)" type="text" required [(ngModel)]="nodeName"
                [attr.data-automation-id]="'new-realm-node-modal-node-name'" ngModel name="nodeName" maxlength="100"
                [(resScrollablePopover)]="popoverErrors.popover" [popoverErrorMessage]="popoverErrors.message"
                [popoverType]="popoverErrors.type" popoverPlacement="bottom" />
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="ipAddress" requiredAsterisk>IP Address: </label>
        </div>
        <div class="modal-row-column-max">
            <input type="text" required [(ngModel)]="ipAddress"
                [attr.data-automation-id]="'new-realm-node-modal-ip-address'" ngModel name="ipAddress"
                (ngModelChange)="ngModelChangeIpLoadingStoragePathList(ipAddress)"
                (change)="onChangeIpAddress(ipAddress)" [(resScrollablePopover)]="alertIpAddress.invalidIP"
                [hasInputError]="alertIpAddress.invalidIP" (focusin)="alertIpAddress.invalidIP = false"
                [popoverErrorMessage]="alertIpAddress.errorMessage" popoverType="error" popoverPlacement="bottom"
                formErrorInput [popoverAutomationId]="'new-realm-node-modal-ip-address-error'" [isSingleLine]="true" />
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="analyticNodeType">Type:</label>
        </div>
        <div class="button-group">
            <button (click)="onClickStandardType()" data-automation-id="new-realm-node-modal-standard-type"
                type="button" [ngClass]="analyticNodeMode === 'STANDARD' ? 'btn-group-active' : 'btn-group-default'">
                <div>Standard</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="analyticNodeMode === 'STANDARD' ? false : true"></i>
            </button>
            <button (click)="onClickExpressType()" data-automation-id="new-realm-node-modal-express-type" type="button"
                [ngClass]="analyticNodeMode === 'EXPRESS' ? 'btn-group-active' : 'btn-group-default'">
                <div>Express</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="analyticNodeMode === 'EXPRESS' ? false : true"></i>
            </button>
            <button (click)="onClickOcrType()" data-automation-id="new-realm-node-modal-ocr-type" type="button"
                [ngClass]="analyticNodeMode === 'OCR' ? 'btn-group-active' : 'btn-group-default'">
                <div>OCR</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="analyticNodeMode === 'OCR' ? false : true"></i>
            </button>
        </div>
    </div>
    <div class="settings-panel-header top-border">Storage</div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="storageName" requiredAsterisk>Temporary Storage Name: </label>
        </div>
        <div class="modal-row-column-max">
            <div>
                <input type="text" required (focusout)="validateOnBlur(storageName, 'Storage')"
                    (keyup)="validateName(storageName, 'Storage')" [(ngModel)]="storageName"
                    [attr.data-automation-id]="'new-realm-node-modal-storage-name'" ngModel name="storageName"
                    maxlength="100" [(resScrollablePopover)]="popoverErrors.storagePopover"
                    [popoverErrorMessage]="popoverErrors.storageMessage" [popoverType]="popoverErrors.storageType"
                    popoverPlacement="bottom" />
            </div>
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label for="storagePath" requiredAsterisk>Temporary Storage Path: </label>
        </div>
        <div class="modal-row-column-max m">
            <res-custom-combo-box #storagePath [automationId]="'new-realm-node-modal-storage-path'"
                [selectedItem]="selectedStoragePath" [onSelectionChanged]="setStoragePath" [items]="storagePathList"
                [allItems]="storagePathList" [maxlength]="100" [fillWidth]="true">
            </res-custom-combo-box>
        </div>
    </div>
    <ng-template #validateButtonTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-validate-button'"
            class="secondary-button validate-button" (click)="validateStoragePath()"
            [disabled]="!validateStoragePathEnabled()">
            <i class="fa fa-check fa-icon sizing-icons"></i>Validate Storage
        </button>
        <div class="validation-error">
            <span class="error-popover" [attr.data-automation-id]="modalAutomationId + '-validation-label'"
                containerClass="success" [container]="'.' + modalClass" [popover]="validationPopTmpl" triggers=""
                #validationPop="bs-popover" placement="left"></span>
            <ng-template #validationPopTmpl>
                <span [attr.data-automation-id]="modalAutomationId +  '-validate-label'">{{isStoragePathValid ?
                    'Storage Path is valid.' : 'Storage Path is invalid.'}}</span>
                <i class="fa fa-close" (click)="validationPop.hide()"
                    [attr.data-automation-id]="modalAutomationId + '-validate-exit-button'"></i>
            </ng-template>
        </div>
    </ng-template>
</res-base-modal>